import { fromNullable } from 'fp-ts/lib/Option';
import { Translated } from '../../locale';
import { DIV, INPUT, LABEL, NodeOrOptional } from '../elements';

export const renderCheckbox =
    (
        name: string,
        title: () => Translated,
        select: (a: boolean) => void,
        renderItem?: NodeOrOptional,
    ) =>
    (isChecked: boolean, runtimeClassName = '') =>
        DIV(
            'checkbox__wrapper',
            LABEL(
                { title: title() },
                fromNullable(renderItem).getOrElse(title()),
                INPUT({
                    name,
                    className: runtimeClassName,
                    type: 'checkbox',
                    checked: isChecked,
                    onChange: () => select(!isChecked),
                }),
            ),
        );

export const renderCheckboxLeft =
    (
        name: string,
        title: () => Translated,
        select: (a: boolean) => void,
        renderItem?: NodeOrOptional,
    ) =>
    (isChecked: boolean, runtimeClassName = '') =>
        DIV(
            { className: 'checkbox__wrapper', key: name },
            LABEL(
                { title: title() },
                INPUT({
                    name,
                    className: runtimeClassName,
                    type: 'checkbox',
                    checked: isChecked,
                    onChange: () => select(!isChecked),
                    key: name,
                }),
                fromNullable(renderItem).getOrElse(title()),
            ),
        );
